<section class="grid" aria-label="Hinweise zur Rechnungsstellung">
  <scale-card>
    <h3 class="grid__title">
      <scale-icon-alert-information></scale-icon-alert-information>
      Hinweise zur Rechnungsstellung
    </h3>
    <scale-list ordered="false">
      <scale-list-item marker="true">
        Bitte erstellen Sie eine Rechnung pro Bestellung
      </scale-list-item>
      <scale-list-item marker="true">
        Die Rechnung muss den zu fakturierenden Wert in voller Höhe ausweisen
      </scale-list-item>
      <scale-list-item marker="true">
        Bitte geben Sie die Bestellnummer auf der Rechnung an
      </scale-list-item>
      <scale-list-item marker="true">
        Postanschrift: 
          GMG Generalmietgesellschaft mbH, PG 9005
          Sternengasse 14-16, Köln
          c/o DTSE Procure to Pay 
          53838 Bonn
      </scale-list-item>
    </scale-list>
  </scale-card>
  <scale-card>
    <h3 class="grid__title">
      <scale-icon-communication-mail-opened></scale-icon-communication-mail-opened>
      Versandadresse
    </h3>
    <scale-list ordered="false">
      <scale-list-item marker="false">
        Bitte senden Sie Ihre Rechnung elektronisch an das zuständige
        Scanzentrum
      </scale-list-item>
      <scale-list-item marker="false">
        <div class="scale-list-item__inner">
          <strong>E-Mail: </strong>
          <a href="mailto:PN-Invoice.GMG-Objekt@invoicedtse.telekom.de">
            PN-Invoice.GMG-Objekt&#64;invoicedtse.telekom.de
          </a>
        </div>
      </scale-list-item>
    </scale-list>
  </scale-card>
  <scale-card>
    <h3 class="grid__title">
      <scale-icon-content-todo-list></scale-icon-content-todo-list>
      Format &amp; Anforderungen
    </h3>
    <scale-list ordered="false">
      <scale-list-item marker="true">
        Akzeptierte Formate: PDF
      </scale-list-item>
      <scale-list-item marker="true">
        Eine Rechnung pro Bestellung
      </scale-list-item>
      <scale-list-item marker="true">
        Angabe der Bestellnummer
      </scale-list-item>
      <scale-list-item marker="true">
        Übereinstimmung mit dem freigegebenen Betrag
      </scale-list-item>
    </scale-list>
  </scale-card>
</section>
